export default __webpack_public_path__ + "static/media/arw-04126.ad287855.jpg";